// 60 40 column layout
import React from 'react';
import { useTheme } from '@emotion/react';
import { isNil } from 'lodash';
import {
  RestModalTemplates,
  type RestModalPerson,
  type RestSixtyFortyColumnActionModal,
  type RestSixtyFortyColumnCodeModal,
  type RestSixtyFortyColumnG2Modal,
  type RestSixtyFortyColumnModal,
  type RestSixtyFortyColumnTwitterModal,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import G2Badge from './sections/g2_badge';
import ModalPerson from './sections/person';
import CustomerHtml from '../customer_html/customer_html';

type Props = {
  title: React.ReactNode;
  detailedAction: React.ReactNode;
  class: string;
  image?: React.ReactNode;
  person?: RestModalPerson;
  twitter?: React.ReactNode;
  quotes?: React.ReactNode;
  offerCode?: React.ReactNode;
  showCode?: boolean;
  fullModalInfo:
    | RestSixtyFortyColumnModal // sixty_forty_column
    | RestSixtyFortyColumnActionModal // sixty_forty_column_action
    | RestSixtyFortyColumnTwitterModal // sixty_forty_column_twitter
    | RestSixtyFortyColumnG2Modal // sixty_forty_column_g2
    | RestSixtyFortyColumnCodeModal; // sixty_forty_column_code
};
export const SixtyFortyColumn: React.FC<Props> = ({
  image,
  twitter,
  quotes,
  person,
  title,
  showCode,
  offerCode,
  detailedAction,
  class: classes,
  fullModalInfo,
}) => {
  const theme = useTheme() as EmotionTheme;

  let injectedStyles: React.CSSProperties = {};
  let g2Rating: React.ReactNode = null;
  if (
    fullModalInfo &&
    fullModalInfo.template === RestModalTemplates.sixty_forty_column_g2
  ) {
    injectedStyles = {
      background: theme.primaryColor,
    };
    g2Rating = <G2Badge gRating={fullModalInfo.requires.g2_rating} />;
  }

  const getLeftColumnContent = () => {
    switch (true) {
      case !!image:
        return image;
      case !!twitter:
        return <div>{twitter}</div>;
      case !!quotes:
        return <div>{quotes}</div>;
      default:
        return null;
    }
  };

  return (
    <div className="sixty-forty-column">
      <div
        className={cs(
          'SFContainer',
          { 'person-layout': !isNil(person) },
          { [classes]: !isNil(person) }
        )}
      >
        <div
          className={cs('left', { 'left-image': image })}
          style={injectedStyles}
        >
          {getLeftColumnContent()}
        </div>
        <div className="right">
          <div className="more-pad">
            <div className="grid-wrap">
              {g2Rating}
              <CustomerHtml value={title} />
              {showCode && offerCode}
              {detailedAction}
            </div>

            {person && <ModalPerson person={person} horizontal />}
          </div>
        </div>
      </div>
    </div>
  );
};
